import React from 'react';
import side_img from '../../assets/images/side-img.png';
import step_ico1 from '../../assets/images/step-up-icon1.png';
import step_ico2 from '../../assets/images/step-up-icon2.png';
import step_ico3 from '../../assets/images/step-up-icon3.png';
import { Link  } from 'react-router-dom';
import { AUTH } from '../../Router/paths';

function StepUp(){
    return(
        <div className="step-up-sec pc-p-6 primary-background">
        <div className="container-fluid px-5">
            <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="side-img">
                        <img src={side_img} alt="Side" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="step-up-content">
                        <div className="primary-heading color-dark">
                            <h3 className="color-secondary mb-5">
                                Step up your work performance, it’s
                                <span className="color-primary">Free</span>
                            </h3>
                            <div className="step-up-box mt-4">
                                <div className="step-up-img">
                                    <img src={step_ico1} alt="Step Up Icon" />
                                </div>
                                <div className="step-up-list">
                                    <h5>Join Free of Cost</h5>
                                    <p>
                                        Register and browse professionals, explore projects, or
                                        even book a consultation.
                                    </p>
                                </div>
                            </div>
                            <div className="step-up-box mt-4">
                                <div className="step-up-img">
                                    <img src={step_ico2} alt="Step Up Icon" />
                                </div>
                                <div className="step-up-list">
                                    <h5>Post a job and onboard top-notch skills</h5>
                                    <p>
                                        Make talent discovery simple: post job or delegate the
                                        search.
                                    </p>
                                </div>
                            </div>
                            <div className="step-up-box mt-4">
                                <div className="step-up-img">
                                    <img src={step_ico3} alt="Step Up Icon" />
                                </div>
                                <div className="step-up-list">
                                    <h5>Work with the best—without breaking the bank</h5>
                                    <p>
                                        Make talent discovery simple: post job or delegate the
                                        search.
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center mt-4">
                                <Link to={AUTH.signup} className="primary-btn primary-bg mr-3">Sign Up for Free</Link>
                                {/* <Link to="" className="primary-btn primary-bg">Learn how to hire</Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default StepUp;